<div class="loadingPage" *ngIf="loadingPage === true">
    <div class="uk-position-center" uk-spinner="ratio: 3" style="filter: brightness(100);"></div>
</div>

<div *ngIf="loading === false && session.isSigned === true">
    <app-menu></app-menu>
    <div>
        <div id="offcanvas-usage" uk-offcanvas>
            <div class="uk-offcanvas-bar uk-padding-remove">
                <app-sidemenu></app-sidemenu>
            </div>
        </div>
        <div class="uk-width-1-1 uk-padding-remove-horizontal">
            <app-submenu></app-submenu>
        </div>
    </div>
</div>

<div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
